// src/components/Header.js
import React from 'react';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Navbar, Offcanvas, Nav, Container } from 'react-bootstrap';
import { BsArrowUpRight } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';






const Header = () => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const navigate = useNavigate();
    const [formData, setFormData] = useState({ name: "", number: "", date: "", time: "", problem: "" });
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Sending...");

        try {
            const res = await fetch("https://sbbstest.in/dr.mahadevan/backend/send-mail-header.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            const data = await res.json();
            console.log("Server Response:", data);

            if (data.status === "success") {
                setStatus("Email sent successfully!");
                navigate("/thank-you");
            } else {
                setStatus(data.message || "Something went wrong.");
            }
        } catch (err) {
            console.error("Error:", err);
            setStatus("Error sending email. Please try again.");
        }
    };

// const handleSubmit =(e)=>{
//     e.preventDefault()
//     console.log("formData", formData)
// }




    return (
        <header className='banner-bg'>
            <section className='header-sec'>
                <div className='container'>
                    <div className='row d-flex justify-content-between align-items-center'>
                        <div className='col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6'>
                            <div className='logo'>
                                <img src="assets/images/logo.svg" alt="Logo" className="img-fluid" style={{ maxWidth: '100%', height: 'auto' }} />
                            </div>
                        </div>
                        <div className='col-xl-9 col-lg-9 col-md-8 col-sm-6 col-6 text-end'>
                            <Navbar expand={false} className="p-0">
                                <Container fluid className="justify-content-end p-0">
                                    <Navbar.Toggle
                                        aria-controls="offcanvasNavbar"
                                        className="border-0"
                                        style={{
                                            borderRadius: '50%',
                                            backgroundColor: '#fff',
                                            height: '40px',
                                            width: '40px',
                                            padding: '0.25rem'
                                        }}
                                    />
                                    <Navbar.Offcanvas
                                        id="offcanvasNavbar"
                                        aria-labelledby="offcanvasNavbarLabel"
                                        placement="end"
                                        className="w-75"
                                    >
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title id="offcanvasNavbarLabel">
                                                <img
                                                    src="assets/images/logo.svg"
                                                    alt=""
                                                    className="img-fluid"
                                                    style={{ maxWidth: '200px' }}
                                                />
                                            </Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <Offcanvas.Body>
                                            <div className="doctor-intro p-3">
                                                <p className="text-muted mb-3">
                                                    Dr. Mahadevan G.R is a highly experienced Senior Physician with over 15 years of dedicated service in the medical field. Specializing in General Medicine, Diabetology, Critical Care, and Geriatric Medicine, he provides comprehensive healthcare solutions at Maya Nursing Home. His patient-centered approach and expertise in managing complex medical conditions have earned him a reputation for excellence in healthcare delivery.
                                                </p>
                                            </div>
                                            {/* <div>
                                                <h5 className="mb-3">Quick Links</h5>
                                                <Nav className="justify-content-end flex-grow-1 pe-3" id='doc-nav-bar'>
                                                    <Nav.Link href="#home" className="py-2">Home</Nav.Link>
                                                    <Nav.Link href="#about" className="py-2">About</Nav.Link>
                                                    <Nav.Link href="#services" className="py-2">Services</Nav.Link>
                                                    <Nav.Link href="#appointment" className="py-2">Appointment</Nav.Link>
                                                    <Nav.Link href="#contact" className="py-2">Contact</Nav.Link>
                                                </Nav>
                                            </div> */}
                                            <div className="contact-info mt-4">
                                                <h5 className="mb-3">Contact Information</h5>
                                                <div className="d-flex flex-column gap-3">
                                                    <a
                                                        href="https://goo.gl/maps/xyz"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-decoration-none text-dark d-flex align-items-center"
                                                        style={{
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onMouseOver={(e) => e.currentTarget.style.color = '#0077b5'}
                                                        onMouseOut={(e) => e.currentTarget.style.color = '#212529'}
                                                    >
                                                        <div className="contact-icon me-3 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                width: '40px',
                                                                height: '40px',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#f8f9fa'
                                                            }}>
                                                            <i className="fas fa-map-marker-alt"></i>
                                                        </div>
                                                        Opp. BSNL Telephone Exchange, 15th Avenue, Ashok Nagar, Chennai - 83
                                                    </a>
                                                    <a
                                                        href="tel:+919876543210"
                                                        className="text-decoration-none text-dark d-flex align-items-center"
                                                        style={{
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onMouseOver={(e) => e.currentTarget.style.color = '#0077b5'}
                                                        onMouseOut={(e) => e.currentTarget.style.color = '#212529'}
                                                    >
                                                        <div className="contact-icon me-3 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                width: '40px',
                                                                height: '40px',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#f8f9fa'
                                                            }}>
                                                            <i className="fas fa-phone"></i>
                                                        </div>
                                                        +91 9940451580
                                                    </a>
                                                    <a
                                                        href="mailto:dr.mahadevan@example.com"
                                                        className="text-decoration-none text-dark d-flex align-items-center"
                                                        style={{
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onMouseOver={(e) => e.currentTarget.style.color = '#0077b5'}
                                                        onMouseOut={(e) => e.currentTarget.style.color = '#212529'}
                                                    >
                                                        <div className="contact-icon me-3 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                width: '40px',
                                                                height: '40px',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#f8f9fa'
                                                            }}>
                                                            <i className="fas fa-envelope"></i>
                                                        </div>
                                                       drgrmaha@gmail.com
                                                    </a>
                                                </div>
                                            </div>
                                        </Offcanvas.Body>
                                    </Navbar.Offcanvas>
                                </Container>
                            </Navbar>
                        </div>
                    </div>
                </div>
            </section>
            <section className="pt---150 pb---100">
                <div className="container">
                    <div className="row">
                        <div className="col-xlg-7 col-lg-7 col-sm-12 text-start">
                            <div className='banner-content'>
                                <h1 className='text-white'>Dr.Mahadevan.G.R</h1>
                                <p className='section-para'>MBBS, MD (General Medicine), IDCCM (Indian diploma in Critical Care Medicine)</p>
                                <p className='section-para'>Currently as Senior physician, Diabetologist, and Consultant in Critical Care & Geriatric Medicine, at Maya Nursing Home Pvt Ltd, Ashok Nagar, Chennai.</p>
                            </div>
                            <div className='d-flex align-items-center gap-2 mt-5'>
                                <Button className='book-appointment-btn' onClick={handleShow}>
                                    Book Appointment
                                </Button>
                                <div style={{ background: '#fff', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000' }}>
                                    <BsArrowUpRight size={20} />
                                </div>
                                <Modal
                                    show={show}
                                    onHide={handleClose}
                                    size="lg"
                                    centered
                                    backdrop="static"
                                    keyboard={false}

                                >
                                    <Modal.Header className="text-white theme-color-bg">
                                        <div className="d-flex align-items-center w-100">
                                            <img
                                                src="assets/images/book-appointment-doctors-image.png"
                                                alt="Dr"
                                                style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    borderRadius: "50%",
                                                    marginRight: "10px"
                                                }}
                                            />
                                            <h5 className="mb-0">Dr. Mahadevan.G.R</h5>
                                            <Button
                                                variant=""
                                                onClick={handleClose}
                                                className="ms-auto text-white fs-4 fw-bold"
                                                style={{ lineHeight: "1" }}
                                            >
                                                &times;
                                            </Button>
                                        </div>
                                    </Modal.Header>

                                    <Modal.Body className="p-0">
                                        <div className="row g-0">
                                            <div className="col-md-6 p-4 appointment-modals">
                                                <h4 className="text-info fw-bold mb-4">Book Appointment</h4>
                                                <Form onSubmit={handleSubmit}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Control
                                                            type="text"
                                                            name="name"
                                                            placeholder="Enter your Name"
                                                            value={formData.name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </Form.Group>

                                                    <Form.Group className="mb-3">
                                                        <Form.Control
                                                            type="text"
                                                            name="number"
                                                            placeholder="Enter your Phone number"
                                                            value={formData.phone}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </Form.Group>

                                                    <div className="row mb-3">
                                                        <div className="col">
                                                            <Form.Control
                                                                type="date"
                                                                name="date"
                                                                value={formData.date}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="col">
                                                            <Form.Control
                                                                type="time"
                                                                name="time"
                                                                value={formData.time}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>

                                                    <Form.Group className="mb-4">
                                                        <Form.Control
                                                            as="textarea"
                                                            name="problem"
                                                            placeholder="Describe Your Problem"
                                                            rows={3}
                                                            value={formData.problem}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>

                                                    {status && <p className="text-danger">{status}</p>}

                                                    <div className="d-flex justify-content-between">
                                                        <Button variant="outline-dark" onClick={handleClose}>
                                                            Cancel
                                                        </Button>
                                                        <Button variant="info" type="submit" className="text-white">
                                                            Send
                                                        </Button>
                                                    </div>
                                                </Form>

                                            </div>
                                            <div className="col-md-6 d-none d-md-block">
                                                <img
                                                    src="assets/images/book-appointment-doctors-image.png"
                                                    alt="Doctors"
                                                    className="img-fluid h-100 w-100"
                                                    style={{
                                                        objectFit: "cover",
                                                        borderTopRightRadius: '0.3rem',
                                                        borderBottomRightRadius: '0.3rem'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </Modal.Body>
                                </Modal>

                            </div>
                        </div>
                        <div className='banner-doctor-image'>
                            <img src="assets/images/banner-doc-img.png" alt="" />
                        </div>
                    </div>
                </div>
            </section>
        </header>
    );
}

export default Header;









